import { Component, effect, inject } from '@angular/core';
import { IUser } from '../../interfaces/user.interface';
import { CommonService } from '../../services/common.service';
import { SharedModule } from '../../../shared/shared.module';
import { CalService } from '../../services/cal.service';

@Component({
  selector: 'app-header',
  imports: [SharedModule],
  templateUrl: './header.html',
  styleUrl: './header.scss'
})
export class Header {


  commonService = inject(CommonService);
  user: IUser = { userName: '', name: '' };

  constructor(private _calService: CalService) {
    effect(() => {
      this.user = this.commonService.getCurrentuser();
    });


  }

  logout() {
    this._calService.signOut();
  }
  ngOnInit() {

  }
}